import React, { Component } from 'react';
import PropTypes from 'prop-types';

/**
 * @class RecentReportView
 * @description renders a single report view with an image, name,
 * last created date, and optional onClick interaction
 */
export default class RecentReportView extends Component {  
    render() {  
        const {
            preview,
            report: {
                createdDate,
                reportID,
                reportName,
                reportPartContent: contentString,
                reportPartType
            }
        } = this.props;
      
        const reportPartContent = JSON.parse(contentString);
        const charttype = reportPartType == 'Chart' ? reportPartContent.properties.chartType : reportPartType;
        
        return ( 
            <div 
                className={`recent-report-view ${charttype}`}
                onClick={ () => preview(reportID)}
            >
                <div className='img-caption'>
                    <span className='report-name'> {reportName}</span>
                   {createdDate ? <span className='report-created-data'>Last View: {createdDate}</span> : '' }
               </div>
            </div>
         );
    }
}

/**
 * @property propTypes
 * @description property types
 * @type {function} preview: callback that for when a user clicks on report
 * @type {object} report: report object that includes date, name, content, id, and type
 */
RecentReportView.prototypes = {
    preview: PropTypes.func,
    report: PropTypes.object.isRequired
};

/**
 * @property defaultProps
 * @description default values for optional props
 */
RecentReportView.defaultProps = {
    preview: () => {}
};



// WEBPACK FOOTER //
// ./ui/modules/Explore/NLQAsk/RecentReportView.jsx